<template>
  <div class="toggle-configuration-mode mtl">
    <div
      class="configuraton-mode-label"
      v-html="lang.get('entries.form.configuration.label')"
    />
    <div class="configuraton-mode-switch">
      <toggle-switch
        id="configuration-mode-toggle-switch"
        name="toggle-switch"
        :on-label="lang.get('buttons.on')"
        :off-label="lang.get('buttons.off')"
        :checked="checkedState"
        @change="onToggle"
      ></toggle-switch>
    </div>
    <confirmation-modal
      modal-id="modal-target-toggle-configuration-mode"
      :show-modal="confirmToggle"
      :confirmation="lang.get('miscellaneous.unsaved_changes')"
      :confirm-button-label="lang.get('buttons.continue')"
      :cancel-button-label="lang.get('buttons.cancel')"
      @closed="confirmToggle = false"
      @confirmed="toggle"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import Storage from '@/lib/storage.js';
import ConfirmationModal from '@/lib/components/Shared/ConfirmationModal';
import ToggleSwitch from '@/lib/components/Shared/ToggleSwitch';
import langMixin from '@/lib/components/Translations/mixins/lang-mixin.js';
import url from '@/lib/url.js';

export default {
  components: {
    ToggleSwitch,
    ConfirmationModal
  },
  mixins: [langMixin],
  data() {
    return {
      confirmToggle: false
    };
  },
  computed: {
    ...mapGetters('entryForm', ['userId', 'selectedTab', 'visibleTabs']),
    ...mapState('entryForm', { disabled: 'uploadInProgress' }),
    ...mapState('entryFormConfiguration', {
      checkedState: 'configurationMode',
      configurationInProgress: 'configurationInProgress'
    }),
    localStoreKey() {
      return 'configurationMode-' + this.userId;
    }
  },
  watch: {
    checkedState(flag) {
      new Storage().set(this.localStoreKey, flag ? 'true' : 'false');
    }
  },
  created() {
    const currentUrl = window.location.href;
    const urlParameter = url.getUrlParameter(currentUrl, 'configuration');
    const flag =
      urlParameter === 'true' ||
      new Storage().get(this.localStoreKey) === 'true';

    if (urlParameter) {
      url.removeUrlParameter(currentUrl, 'configuration');
    }

    this.enableConfigurationMode(flag);
  },
  methods: {
    ...mapActions('entryFormConfiguration', ['restoreConfiguration']),
    ...mapMutations('entryForm', ['selectTab']),
    ...mapMutations('entryFormConfiguration', [
      'setConfigurationInProgressFlag',
      'enableConfigurationMode'
    ]),
    onToggle() {
      if (this.configurationInProgress) {
        this.confirmToggle = true;
      } else {
        this.toggle();
      }
    },
    toggle() {
      this.restoreConfiguration().then(() => {
        this.setConfigurationInProgressFlag(false);
        this.enableConfigurationMode(!this.checkedState);
        this.switchToTheFirstTab();
      });
    },
    switchToTheFirstTab() {
      // If configuration mode is on keep the current tab open
      if (this.checkedState) {
        return;
      }

      // If configuration mode is off and the selected tab is disabled
      // switch to the first tab
      if (this.selectedTab && this.selectedTab.disabled) {
        this.selectTab(this.visibleTabs[0].id);
      }
    }
  }
};
</script>
